import { jsx } from 'react/jsx-runtime';
import { VirtualGrid } from '@fabric-app/ui/components/VirtualGrid/VirtualGrid';
import { IntersectionObserverAnchor } from '@fabric-app/ui/components/IntersectionObserver/IntersectionObserver';
import ResourcePreviewEnhanced from '../../ResourcePreview/ResourcePreviewEnhanced.js';
import { ResourceSearchResultItem } from './ResourcePreviewItem/ResourceSearchResultItem.js';
import { ResourceSearchResultItemSkeleton } from './ResourcePreviewItem/ResourceSearchResultItemSkeleton.js';
import { RESOURCE_GRID_PREVIEW_CONTENT } from '@fabric-app/ui/theme/resourcePreviewConstants';

const VirtualSearchResultList = ({ containerWidth = 0, zoomLevel, resources, resourcesTotalCount = 0, selectedResourceIds, scrollYMargin, disableItemPreviewContextMenu, canMultiSelect, colorLabels, disableDrag, onInfiniteTrigger, virtualGridOptions, resourcePreviewProps, onResourceClick, disableLayoutAnimation }) => {
  return /* @__PURE__ */ jsx(VirtualGrid, {
    zoomLevel: 1,
    columnsCount: 1,
    rowHeight: (RESOURCE_GRID_PREVIEW_CONTENT.height / 2 + 24) * (zoomLevel ?? 1),
    itemsCount: resourcesTotalCount || resources.length,
    scrollYMargin,
    containerWidth,
    rowGap: 16,
    renderItem: ({ index }) => {
      const resource = resources[index];
      if (resource) {
        return /* @__PURE__ */ jsx(ResourcePreviewEnhanced, {
          viewMode: "Grid",
          resource,
          selected: selectedResourceIds && selectedResourceIds.includes(resource?.id ?? ""),
          disableContextMenu: disableItemPreviewContextMenu,
          canMultiSelect,
          colorLabels,
          isSelectable: true,
          resourcePreviewProps,
          zoomLevel,
          onClick: onResourceClick,
          disableDrag,
          disableLayoutAnimation,
          ResourcePreviewComponent: ResourceSearchResultItem
        }, resource.id);
      }
      if (index < resourcesTotalCount) {
        return /* @__PURE__ */ jsx(ResourceSearchResultItemSkeleton, {
          zoomLevel: zoomLevel ?? 1,
          children: index % 10 === 0 && onInfiniteTrigger && /* @__PURE__ */ jsx(IntersectionObserverAnchor, {
            onIntersect: onInfiniteTrigger,
            rootMargin: "500px",
            debounceDelay: 200,
            // for some reason on ios this is not triggering with at leat height of 1px
            style: {
              height: 1,
              position: "absolute"
            }
          }, `${resources.length}-${resources[resources.length - 1]?.id}`)
        }, index);
      }
      return null;
    },
    ...virtualGridOptions
  });
};

export { VirtualSearchResultList };
//# sourceMappingURL=VirtualSearchResultList.js.map
